import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

declare let _: any;

@Component({
  selector: 'app-label-input-search',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './label-input-search.component.html',
  styleUrl: './label-input-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabelInputSearchComponent {
  highlightIndex = -1;
  allData: Array<any> = [];
  searchEntries: Array<any> = [];
  selectedEntries: Array<any> = [];
  valueKey = '';

  @Input()
  set setData(obj: any){
    const base = this;
    base.allData = obj ? [...obj] : [];
    base.searchEntries = obj ? [...obj] : [];
  }

  @Input()
  set selectedData(obj: any){
    const base = this;
    base.selectedEntries = obj ? [...obj] : [];
  }

  @Input() set displayKey(key: string){
    if (key){
      this.valueKey = key;
    }
  }

  @Input() removeLabelClass;

  @Input() displaySingleItem;

  @Output()
  onLabelSearchSelection: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onLabelRemove: EventEmitter<any> = new EventEmitter<any>();

  constructor(private changeDetectoref: ChangeDetectorRef){}

  filterEntries($event){
    const base = this;
    const searchString = $event.target.value || '';
    if (searchString){
      this.searchEntries = _.filter(this.allData, function(obj){
        return obj[base.valueKey].toLowerCase().indexOf(searchString.toLowerCase()) != -1;
      });
    } else{
      this.searchEntries = _.cloneDeep(this.allData);
    }
  }

  highlightNext($event){
    if (this.highlightIndex < this.searchEntries.length - 1){
      this.highlightIndex += 1;
    } else{
      this.highlightIndex = 0;
    }
  }

  highlightPrevious($event){
    if (this.highlightIndex > 0){
      this.highlightIndex -= 1;
    } else{
      this.highlightIndex = this.searchEntries.length - 1;
    }
  }

  highlightAtIndex(index){
    this.highlightIndex = index;
  }

  triggerOnSelect($event, entry){
    this.onLabelSearchSelection.next(entry);
  }

  removeLabel(entry){
    this.onLabelRemove.next(entry);
  }

}
